import { Button, Col, Row, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { DrawerAccompaniments, WrapperCardAccompaniments } from "./styled";
import { TableAccompaniments } from "./TableAccompaniments";
import React from "react";
import { AccompanimentsForm } from "./form";

const { Title } = Typography;

export const Accompaniments = () => {
  const [openModalCreate, setOpenModalCreate] = React.useState<boolean>(false);

  return (
    <AdminMenuLayout pageDescription="Acompañamientos" title="Acompañamientos">
      <WrapperCardAccompaniments>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title
              level={3}
              style={{
                margin: 0,
                fontWeight: 600,
                color: "#262626",
              }}
            >
              Acompañamientos
            </Title>
            <Button
              type="primary"
              size="large"
              onClick={() => setOpenModalCreate(true)}
              icon={<PlusOutlined />}
              style={{
                borderRadius: 20,
                height: 44,
                paddingLeft: 24,
                paddingRight: 24,
                fontWeight: 600,
                fontSize: 15,
                boxShadow: "0 2px 8px rgba(233, 87, 53, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Agregar acompañamiento
            </Button>
          </Col>
        </Row>

        <TableAccompaniments />
        <DrawerAccompaniments
          title="Agregar acompañamiento"
          open={openModalCreate}
          width={420}
          centered
          destroyOnClose
          footer={null}
          onCancel={() => setOpenModalCreate(false)}
        >
          <AccompanimentsForm setOpenModalCreate={setOpenModalCreate} />
        </DrawerAccompaniments>
      </WrapperCardAccompaniments>
    </AdminMenuLayout>
  );
};
